import React from "react";
import { EntityEditProvider } from "@/contexts/EntityEditContext";
import type { EntityEditProviderProps } from "@/types/contexts/entityEdit";
import { ExpenseType } from "@/types/db/expenses";
import { expenseService } from "@/services/expenseService";

interface ExpenseEditProviderProps extends Omit<EntityEditProviderProps<ExpenseType>, "onSave" | "entityName"> {
  children: React.ReactNode;
}

export function ExpenseEditProvider({ children, entityData, loading, onSaveSuccess }: ExpenseEditProviderProps) {
  const handleSave = async (formData: Partial<ExpenseType>): Promise<ExpenseType> => {
    if (!entityData?.id) {
      throw new Error("No expense ID available");
    }

    // Strip out read-only fields
    const { id, created_at, tenant_id, ...cleanFormData } = formData;

    // Update the expense
    const updatedExpense = await expenseService.updateExpense(entityData.id, cleanFormData);

    // Fetch complete data to return
    const completeExpense = await expenseService.getExpenseById(entityData.id);
    if (!completeExpense) {
      throw new Error("Failed to fetch updated expense data");
    }

    return completeExpense;
  };

  return (
    <EntityEditProvider
      entityData={entityData}
      loading={loading}
      onSave={handleSave}
      onSaveSuccess={onSaveSuccess}
      entityName="Expense"
    >
      {children}
    </EntityEditProvider>
  );
}
